import { useRouter } from 'vue-router';

export type NavItem = {
    label: string,
    link: string,
    active?: boolean,
    subItems?: NavItems,
};

export type NavItems = NavItem[];

export function getAdminNavItems(): NavItems {
    const router = useRouter();

    return [
        { label: 'Аукционы', link: router.resolve({ name: 'AuctionsList' }).href },
        { label: 'Авто', link: router.resolve({ name: 'CarsList' }).href },
        {
            label: 'Отчеты',
            link: '#',
            subItems: [
                { label: 'Отчет по ставкам', link: router.resolve({ name: 'BidReportList' }).href },
                { label: 'Бухгалтерский отчет', link: router.resolve({ name: 'ReportAccounting' }).href },
                { label: 'Отчет о размещении и продаже', link: router.resolve({ name: 'ReportPlacementSale' }).href },
                { label: 'Отчет об аукционах', link: router.resolve({ name: 'ReportAuctions' }).href },
            ],
        },
        {
            label: 'Справочники',
            link: '#',
            subItems: [
                { label: 'Пользователи', link: router.resolve({ name: 'HandbookUsers' }).href },
                { label: 'Дилеры', link: router.resolve({ name: 'HandbookDealers' }).href },
                { label: 'Холдинги', link: router.resolve({ name: 'HandbookHoldings' }).href },
                { label: 'Модели авто', link: router.resolve({ name: 'HandbookModels' }).href },
                { label: 'Комплектации', link: router.resolve({ name: 'HandbookComplectations' }).href },
                { label: 'Города', link: router.resolve({ name: 'HandbookCities' }).href },
                { label: 'Тарифы на доставку', link: router.resolve({ name: 'HandbookDeliveryPrices' }).href },
            ],
        },
    ];
}

export function getDealerNavItems(): NavItems {
    const router = useRouter();

    return [
        { label: 'Аукционы', link: router.resolve({ name: 'AuctionsList' }).href },
        { label: 'Мои ставки', link: router.resolve({ name: 'BetsList' }).href },
        { label: 'Авто', link: router.resolve({ name: 'CarsList' }).href },
    ];
}
